import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useRef, useMemo } from 'react';
import { Pill } from '../Pill/Pill.js';
import { Tooltip } from 'primereact/tooltip';

var StatusPillValue;
(function (StatusPillValue) {
  // Blue
  StatusPillValue["VERY_UNLIKELY"] = "VERY_UNLIKELY";
  // Green
  StatusPillValue["LOW"] = "LOW";
  StatusPillValue["MINOR"] = "MINOR";
  StatusPillValue["NEGLIGIBLE"] = "NEGLIGIBLE";
  StatusPillValue["UNLIKELY"] = "UNLIKELY";
  // Yellow
  StatusPillValue["MODERATE"] = "MODERATE";
  StatusPillValue["MEDIUM"] = "MEDIUM";
  StatusPillValue["POSSIBLE"] = "POSSIBLE";
  // Orange
  StatusPillValue["CRITICAL"] = "CRITICAL";
  StatusPillValue["SIGNIFICANT"] = "SIGNIFICANT";
  StatusPillValue["LIKELY"] = "LIKELY";
  // Red
  StatusPillValue["DISASTROUS"] = "DISASTROUS";
  StatusPillValue["HIGH"] = "HIGH";
  StatusPillValue["MAJOR"] = "MAJOR";
  StatusPillValue["VERY_LIKELY"] = "VERY_LIKELY";
})(StatusPillValue || (StatusPillValue = {}));
function getStatusPillValue(value) {
  const statusPillValues = Object.values(StatusPillValue);
  return statusPillValues.find(statusPillValue => statusPillValue.toLowerCase() === value.toLowerCase());
}
function getStatusPillColor(value) {
  switch (value) {
    case StatusPillValue.VERY_LIKELY:
      return '#1697F1';
    case StatusPillValue.LOW:
    case StatusPillValue.MINOR:
    case StatusPillValue.NEGLIGIBLE:
    case StatusPillValue.UNLIKELY:
      return '#92CF55';
    case StatusPillValue.MODERATE:
    case StatusPillValue.MEDIUM:
    case StatusPillValue.POSSIBLE:
      return '#FFE642';
    case StatusPillValue.CRITICAL:
    case StatusPillValue.SIGNIFICANT:
    case StatusPillValue.LIKELY:
      return '#FFA229';
    case StatusPillValue.DISASTROUS:
    case StatusPillValue.HIGH:
    case StatusPillValue.MAJOR:
    case StatusPillValue.VERY_UNLIKELY:
      return '#F04A2D';
    default:
      return '';
  }
}
function StatusPill(_ref) {
  let {
    value,
    onlyContent,
    fallback,
    customColor,
    customLabel,
    tooltip
  } = _ref;
  const pillRef = useRef(null);
  const isSupportedValue = Object.keys(StatusPillValue).includes(value);
  const label = useMemo(() => {
    if (customLabel) {
      return customLabel;
    }
    return value.replace('_', ' ').toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
  }, [value, customLabel]);
  const backgroundColor = useMemo(() => {
    if (customColor) {
      return customColor;
    }
    return getStatusPillColor(value);
  }, [value, customColor]);
  if (!customColor && !isSupportedValue) {
    return fallback !== null && fallback !== void 0 ? fallback : null;
  }
  const content = jsxs("div", {
    className: "flex align-items-center",
    children: [jsx("div", {
      className: "status-pill--indicator",
      style: {
        backgroundColor
      }
    }), label]
  });
  const pillContent = onlyContent ? content : jsx(Pill, {
    className: "flex align-items-center",
    children: content
  });
  if (!tooltip) {
    return pillContent;
  }
  return jsxs(Fragment, {
    children: [jsx(Tooltip, {
      target: pillRef,
      content: tooltip,
      position: "top"
    }), jsx("span", {
      ref: pillRef,
      className: "inline-flex",
      children: pillContent
    })]
  });
}

export { StatusPill, StatusPillValue, getStatusPillColor, getStatusPillValue };
